import React from 'react';
import '../App.css';
import './services1.css';
import './app.css';
import SEO from '../SEO';
import PopUp_Divs from './popup_divs.js'
import Purple_poly_fall from '../images/puple_poly_fall.mp4'; 
import { LiaClipboardListSolid } from "react-icons/lia";
import { GiGearHammer } from "react-icons/gi";
import { LuRocket } from "react-icons/lu";
import App from '../images/applications2.gif';
import Code from '../images/coding2.gif';
import Cross_Platform from '../images/responsive2.gif';
import Scale from '../images/scalability2.gif';
import Gear from '../images/gear2.gif';
import BarChart from '../images/bar-chart3.gif';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js' 


const AppDev = () => {

	useScrollBehavior();

	const title = "App Development Services | Yokai Software";
const description = "Yokai Software builds custom mobile apps and web applications with scalable architecture, strong user experience, and reliable performance.";
const canonical = "https://yokaisoftware.com/app";
const image = "https://yokaisoftware.com/yokai_apple_touch_icon2.png";

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://yokaisoftware.com/#organization",
      name: "Yokai Software",
      url: "https://yokaisoftware.com/",
      logo: "https://yokaisoftware.com/yokai_apple_touch_icon2.png",
      description:
        "Yokai Software provides web design, web development, SEO, app development, and digital solutions for businesses."
    },
    {
      "@type": "Service",
      "@id": "https://yokaisoftware.com/app#service",
      serviceType: "App Development",
      name: "App Development Services",
      provider: {
        "@id": "https://yokaisoftware.com/#organization"
      },
      url: "https://yokaisoftware.com/app",
      description:
        "Custom mobile apps and web applications built for performance, scalability, and long-term business growth."
    },
    {
      "@type": "WebPage",
      "@id": "https://yokaisoftware.com/app#webpage",
      url: "https://yokaisoftware.com/app",
      name: "App Development Services | Yokai Software",
      description:
        "Yokai Software builds custom mobile apps and web applications with scalable architecture, strong user experience, and reliable performance.",
      isPartOf: {
        "@id": "https://yokaisoftware.com/#website"
      },
      about: {
        "@id": "https://yokaisoftware.com/app#service"
      }
    }
  ]
};

	 const ROUTES = {
      "Learn More": "/about",
      "Contact Us": "/ContactPage",
      "See Plans": "/about",
      "Get Support": "/ContactPage",
      "View Case Studies": "/portfolio",
    };
    
    React.useEffect(() => {
      const handler = (e) => {
        
        const el = e.target.closest('button, a, [role="button"], .btn, .button, .my-button-class, [data-button]');
        if (!el) return;
    
        const label = (el.textContent || "").trim();
        const path = ROUTES[label];
        if (!path) return;           
         sessionStorage.removeItem('scrollPosition');
       
        window.scrollTo(0, 0);
    
        e.preventDefault();          
        window.location.assign(path); 
      };
      
      document.addEventListener('click', handler, true);
      return () => document.removeEventListener('click', handler, true);
    }, []);
    
	return (
		<div id='services_div1'>

			<SEO
      			title={title}
      			description={description}
      			canonical={canonical}
      			image={image}
      			schema={schema}
    		/> 

			<div className='module_service' id='service_moduleOne'>
				<video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
					<source src={Purple_poly_fall} type="video/mp4" fetchpriority="high"/>
						Your browser does not support the video tag.
				</video>
				<div id='services_heading1'><h1>App Development (Mobile/Web Apps)</h1>
				</div>
			</div>
            <div className='module_service' id='service_moduleTwo'>
				<div id='service_mod2_container'>
					<div id='service_mod2_inner1'>
						<h1 id='service_about_h1'>Build Apps That Power Your Business</h1>
						<h2>From Idea to Launch — Seamless App Development That Delivers</h2>
					</div>
					<div id='service_mod2_inner2'>
						<p>In today's digital world, an app isn't just an accessory — it's a gateway to your 
                            customers. Whether you need a sleek mobile app for iOS or Android, or a powerful 
                            web application that scales with your business, we bring your vision to life. At 
                            Yokai, we design and develop apps that combine great user experience, solid 
                            performance, and reliable backend systems.
                            <br></br>
                            <br></br>
                            From strategy and design to coding and deployment, our process is built to deliver 
                            apps that not only look amazing but also work flawlessly. Every feature is crafted 
                            with your goals in mind, ensuring your app becomes a tool for real growth — not just 
                            another download.</p>
					</div>
				</div>

			</div>
             <div className='module_service' id='service_moduleTwo_app'>
                <div id='mod4_div2_service_app'>
					<div id='mod4_div2_service_heading'>
				  		<h1>From Concept to Growth: Our App Development Formula</h1>
						
					</div>
					<div id='mod4_sub_div_container_service'>
						<div className='mod4_sub_div_service'>		
				  				<div id='mod4_Sub_div_icon1_service'>
									<img src={App} alt="App icon" className="plan" />
								</div>
								<h2>User-Centered Design</h2>
								<p>We design apps with your customers in mind. Every screen, 
                                    button, and interaction is built to be intuitive and engaging, 
                                    so users love coming back.</p>
						</div>
						<div className='mod4_sub_div_service'>
				  				<div id='mod4_Sub_div_icon2_service'>
				  					<img src={Code} alt="Sales icon" className="sales" />
								</div>		
								<h2>Powerful Backends</h2>
								<p>A great app needs a strong foundation. Our Node.js and Express backends ensure speed, security, and scalability for every feature you need.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon3_service'>
								<img src={Cross_Platform} alt="Business icon" className="business" />
							</div>
							<h2>Cross-Platform Development</h2>
							<p>Whether your audience is on iOS, Android, or the web, we build apps that work seamlessly across platforms without sacrificing performance.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon4_service'>
								<img src={Scale} alt="Seo icon" className="seo" />
							</div>
							<h2>Scalable Solutions</h2>
							<p>As your business grows, your app grows with you. Our development process focuses on scalability so you never outgrow your software.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon5_service'>
								<img src={Gear} alt="Website icon" className="website_list" />
							</div>
							<h2>Ongoing Support</h2>
							<p>Launching an app is just the beginning. We provide continuous support, updates, and improvements to keep your app competitive and reliable.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon6_service'>
								<img src={BarChart} alt="Boss icon" className="boss" />
							</div>
							<h2>Data-Driven Insights</h2>
							<p>We integrate analytics so you can track performance, measure user engagement, and make informed decisions that keep your app improving.</p>
						</div>
					</div>

				</div>			
                
             </div>
			 <div className='module_service' id='service_moduleThree'>
				<div id='service_mod2_container2_app'>
					<div className="conversion-module_app">
						<div id='conversion-module_subdiv_app'>
				  			<h2>From concept to launch, we build apps that work beautifully and perform flawlessly.</h2>

  						<p>
    						We approach app development with one goal: creating tools your users love to use. 
                            That means intuitive interfaces, stable performance, and features that solve real 
                            problems. Our process ensures your app is not just built — it's built for growth.
  						</p>
						</div>

  				<div className="conversion-funnel">
    				<div className="step"><LiaClipboardListSolid  className="icon_app"/><strong>Plan:</strong> Define clear goals, user needs, and technical requirements.</div>
    				<div className="step"><GiGearHammer className="icon_app"/><strong>Build:</strong> Design and develop apps with clean code, reliable backends, and scalable architecture.</div>
    				<div className="step"><LuRocket className="icon_app"/><strong>Launch:</strong> Deploy with confidence, optimize performance, and provide ongoing updates.</div>
  				</div>

  				<ul className="conversion-points">
    				<li>Cross-platform functionality (iOS, Android, Web)</li>
    				<li>Speed and responsiveness tuned for mobile-first experiences</li>
    				<li>Secure backends with Node.js + Express</li>
    				<li>Scalable architecture ready to grow with your business</li>
                    <li>User-focused design that keeps people engaged</li>
  				</ul>

  				{/*<div className="conversion-ctas">
    				<div href="#contact" id='btn-primary' className="btn">Get a Free Quote</div>
    				<div href="#work" id='btn_service' className="btn">View Case Studies</div>
  				</div>*/}
				</div>
				</div>
			 </div>
			<div className='module_service' id='service_moduleFour'>
                
				<div id='mod4_div2_service'>
					<div id='mod4_div2_service_heading'>
				  		<h1>Apps Built for Connection, Performance, and Results</h1>
						<h1>From Idea to Impact: Our App Development Promise</h1>
					</div>
                    <PopUp_Divs
				pageKey="app"
                data={[
                    { 
						buttons: ["Learn More", "Contact Us"], 
                        h2: "Why Apps Matter", 
                        p: "An app isn't just software — it's a direct connection between your business and your customers. From booking services to making purchases, apps create faster, easier, and more personalized experiences that build loyalty and drive growth." 
                    },
                    { 
						buttons: ["See Plans", "Get Support"],
                        h2: "Our Development Promise", 
                        p: "Every app we build is designed to be fast, reliable, and scalable. We don't cut corners — we create apps that perform as beautifully as they look, with backends that can handle real growth." 
                    },
                    { 
						buttons: ["View Case Studies"],
                        h2: "Your Success Is Our Goal", 
                        p: "We measure our success by the results our clients achieve. Whether it's more downloads, higher engagement, or increased revenue, our team works to make sure your app is not just launched — but thriving." 
                    }
                  ]}
                />
				</div>
			</div>
			<Footer/>
			
		</div>
	);
};

export default AppDev;